module.exports = __webpack_public_path__ + "img/Steering Wheel.ecb15609.png";